<template>
  <!-- eslint-disable max-len -->
  <VModal @close="$emit('close')">
    <template #default="modalProps">
      <div
        class="rounded shadow-xs bg-gray-100 overflow-hidden mx-auto lg:max-w-7xl sm:w-full h-full flex flex-col"
      >
        <div class="flex-none px-4 sm:px-6 py-5 border-b bg-white">
          <div class="flex items-center justify-between">
            <div class="flex-1">
              <h1 class="text-sm">Email message manager</h1>
            </div>
            <button
              type="button"
              class="rounded-md text-gray-400 hover:text-gray-800 focus:outline-none"
              @click="modalProps.close"
            >
              <svg
                class="h-6 w-6"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
        </div>
        <template>
          <div class="flex-1 flex divide-x min-h-0">
            <div class="flex flex-col min-h-0 w-96 flex-none divide-y bg-white">
              <div class="p-4">
                <BaseButton primary class="w-full" @click="openWriteEmailDialog">
                  Write new email
                </BaseButton>
              </div>
              <div class="overflow-y-auto">
                <EmailMessageList
                  ref="emailMessageList"
                  :pipeline-stage-id="pipelineStage.id"
                  :current-email-message="currentEmailMessage"
                  @email-message:focus="handleEmailMessageFocus"
                />
              </div>
            </div>
            <EmailMessageManager
              v-if="currentEmailMessage"
              :email-message="currentEmailMessage"
              :pipeline-stage="pipelineStage"
              @email-message-manager:change="handleEmailMessageManagerChange"
            />
          </div>
        </template>
      </div>
    </template>
  </VModal>
</template>

<script>
// import { accountThirdPartyServicesClient } from '@/api/clients';
import EmailMessageList from './EmailMessageList.vue';
import EmailMessageManager from './EmailMessageManager.vue';

export default {
  name: 'PipelineStageEmailMessageManager',
  components: {
    EmailMessageList,
    EmailMessageManager,
  },
  props: {
    pipeline: {
      type: Object,
      required: true,
    },
    pipelineStage: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      currentEmailMessage: null,
    };
  },
  methods: {
    handleEmailMessageFocus(emailMessage) {
      this.currentEmailMessageForm = null;
      this.currentEmailMessage = emailMessage;
    },
    handleEmailMessageManagerChange() {
      this.$refs.emailMessageList.fetchData();
    },
    openWriteEmailDialog() {
      this.$modal.show({
        component: () =>
          import(
            '@/components/PipelineStageEmailMessage/WriteEmailMessageDialog/WriteEmailMessageDialog.vue'
          ),
        props: {
          accountId: this.pipeline.accountId,
          pipelineStageId: this.pipelineStage.id,
        },
        on: {
          saved: () => {
            this.$refs.emailMessageList.fetchData();
          },
          sent: () => {
            this.$refs.emailMessageList.fetchData();
          },
        },
        hideEvent: 'close',
      });
    },
  },
};
</script>
